import * as React from "react";

import { cn } from "@/lib/utils";

interface LabelProps {
	readonly className?: string;
	readonly children: React.ReactNode;
	readonly htmlFor?: string;
}
function Label({ className, children, htmlFor }: LabelProps) {
	const finalClassName = cn(
		"flex items-center gap-2",
		"text-sm font-medium",
		"[disabled=true]:opacity-50 [disabled=true]:cursor-not-allowed",
		className,
	);

	return <label className={finalClassName} children={children} htmlFor={htmlFor} />;
}

function LabelField(props: {
	readonly label: string;
	readonly children: React.ReactNode;
}) {
	return (
		<Label className="flex flex-col gap-1.5">
			<div className="text-sm font-medium [disabled=true]:opacity-50 [disabled=true]:cursor-not-allowed">
				{props.label}
			</div>
			{props.children}
		</Label>
	);
}

export { Label, LabelField };
